module.exports = __webpack_public_path__ + "static/media/Phenikaa_School.a991091a.jpg";